import { render, staticRenderFns } from "./PopupDetailsBuilding.vue?vue&type=template&id=63ff47a3&"
import script from "./PopupDetailsBuilding.vue?vue&type=script&lang=js&"
export * from "./PopupDetailsBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports